export default __webpack_public_path__ + "static/media/Kuthcheman Guardsman Pike.68f0dd45.jpg";